import { BreakpointValues } from "@/components/_primitives/utils/breakpoints";
import { getItemAttributes } from "@/components/_primitives/utils/getItemAttributes";
import { y_variant_small } from "@/utils/animation/transitions";
import * as motion from "motion/react-m";
import React from "react";

interface GridItemProps {
  children: React.ReactNode;
  itemWidth?: string | BreakpointValues;
  itemHeight?: string | BreakpointValues;
  className?: string;
}

const GridItem = ({
  children,
  itemWidth = "auto",
  itemHeight = "auto",
  className = "",
}: GridItemProps) => {
  const itemAttr = getItemAttributes({
    itemWidth,
    itemHeight,
    className,
    itemAttrFor: "grid",
  });

  return (
    <motion.li
      {...itemAttr}
      variants={y_variant_small}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      {children}
    </motion.li>
  );
};

export default GridItem;
